module.exports = __webpack_public_path__ + "static/media/CaptureRESP3.ad849960.PNG";